module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f633f2f711294b45c7d.worker.js");
};